<template>
  <v-row no-gutters class="registrationSetup pa-3" v-if="isLoading">
    <v-card>
      <v-row>
        <v-col sm="12" style="text-align: left">
          <v-list-item three-line style="border-bottom: none;">
            <v-list-item-content>

              <v-list-item-title class="headline">
                <v-row no-gutters>
                  <v-col md="4" class="col-left">
                    <v-text-field
                      hide-details="auto"
                      :label="$t('dashboard.menu.eventDetails.registrationAd')"
                      v-model="adTitle"
                      style="margin: 10px 0;"
                      outlined
                      dense
                      @input="sendMessage('adTitle')"
                      :hint="$t('dashboard.menu.eventDetails.registrationAdToolTipster')"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                  <v-col md="4" class="col-right">
                    <v-textarea
                      :label="$t('dashboard.menu.eventDetails.adMessage')"
                      hide-details="auto"
                      v-model="adMessage"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('adMessage')"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-list-item-title>
              
              <v-list-item-title class="headline">
                <v-row no-gutters class="mt-4">
                  <v-col md="4" class="col-left">
                    <v-text-field
                      hide-details="auto"
                      :label="$t('dashboard.menu.eventDetails.paypalEmail')"
                      v-model="paypalEmail"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('adTitle')"
                      :hint="$t('dashboard.menu.eventDetails.paypalemailToolTipster')"
                      persistent-hint
                      :placeholder="eventDetails.paypalEmail"
                    ></v-text-field>
                  </v-col>
                  <v-col md="4" class="col-right">
                    <v-text-field
                      hide-details="auto"
                      :label="$t('dashboard.menu.eventDetails.regFee')"
                      v-model="regFee"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('regFee')"
                      :hint="$t('dashboard.menu.eventDetails.regFeeToolTipster')"
                      persistent-hint
                      :placeholder="eventDetails.regFee === undefined ? '' : eventDetails.regFee.toString()"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-list-item-title>

              <v-list-item-title class="headline">
                <v-row no-gutters class="mt-4">
                  <v-col md="4" class="col-left datetime-outline" >
                    <v-datetime-picker 
                      :label="$t('dashboard.menu.eventDetails.onlineRegistrationOpen')"
                      :datetime="registrationOpen" 
                      :text-field-props="textFieldProps" 
                      :time-picker-props="timeProps" 
                      :date-picker-props="{
                        'header-date-format': this.$datePicker.formatDateHeader,
                        'title-date-format': this.$datePicker.formatTitleDate,
                        'weekday-format': this.$datePicker.formatWeekday,
                        'month-format': this.$datePicker.formatMonth
                      }" 
                      dateFormat="yyyy-MM-dd" 
                      time-format="HH:mm:ss" 
                      @input="saveRegistrationOpen"
                    >
                      <template slot="actions" slot-scope="{ parent }">
                        <v-btn color="error" @click="parent.okHandler">{{$t('common.cancel')}}</v-btn>
                        <v-btn color="success" @click="parent.okHandler">{{$t('common.done')}}</v-btn>
                      </template>
                      <template slot="dateIcon">
                        <v-icon>fas fa-calendar</v-icon>
                      </template>
                      <template slot="timeIcon">
                        <v-icon>fas fa-clock</v-icon>
                      </template>
                    </v-datetime-picker>
                    <div class="caption">{{ $t('dashboard.menu.eventDetails.onlineRegistrationOpenToolTipster') }}</div> 
                  </v-col>
                  <v-col md="4" class="col-right datetime-outline">
                    <v-datetime-picker 
                      :label="$t('dashboard.menu.eventDetails.onlineRegistrationClosed')"
                      :datetime="registrationClosed" 
                      :text-field-props="textFieldProps" 
                      :time-picker-props="timeProps" 
                      :date-picker-props="{
                        'header-date-format': this.$datePicker.formatDateHeader,
                        'title-date-format': this.$datePicker.formatTitleDate,
                        'weekday-format': this.$datePicker.formatWeekday,
                        'month-format': this.$datePicker.formatMonth
                      }" 
                      dateFormat="yyyy-MM-dd" 
                      time-format="HH:mm:ss" 
                      @input="saveRegistrationClose"
                    >
                      <template slot="actions" slot-scope="{ parent }">
                        <v-btn color="error" @click.native="parent.okHandler">{{$t('common.cancel')}}</v-btn>
                        <v-btn color="success" @click="parent.okHandler">{{$t('common.done')}}</v-btn>
                      </template>
                      <template slot="dateIcon">
                        <v-icon>fas fa-calendar</v-icon>
                      </template>
                      <template slot="timeIcon">
                        <v-icon>fas fa-clock</v-icon>
                      </template>
                    </v-datetime-picker>
                    <div class="caption">{{ $t('dashboard.menu.eventDetails.onlineRegistrationClosedToolTipster') }}</div>
                  </v-col>
                </v-row>
              </v-list-item-title>

              <v-list-item-title class="headline">
                <v-row no-gutters class="mt-4">
                  <v-col md="4" class="col-left">
                    <v-text-field
                      hide-details="auto"
                      :label="$t('dashboard.menu.eventDetails.maxRegistrants')"
                      v-model="maxRegistrants"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('maxRegistrants')"
                      :hint="$t('dashboard.menu.eventDetails.maxRegistrantsToolTipster')"
                      persistent-hint
                      :placeholder="eventDetails.maxRegistrants === undefined ? '' : eventDetails.maxRegistrants.toString()"
                    ></v-text-field>
                  </v-col>
                  <v-col md="4" class="col-right">
                    <v-text-field
                      hide-details="auto"
                      :label="$t('dashboard.menu.eventDetails.waitingListLimit')"
                      v-model="waitingListLimit"
                      style="margin: 10px 0"
                      outlined
                      dense
                      @input="sendMessage('waitingListLimit')"
                      :hint="$t('dashboard.menu.eventDetails.waitingListLimitToolTipster')"
                      persistent-hint
                      :placeholder="eventDetails.waitingListLimit === undefined ? '' : eventDetails.waitingListLimit.toString()"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-list-item-title>

              <v-list-item-title class="headline">
                <v-row no-gutters class="mt-4">
                  <v-col md="4" class="col-left">
                    <v-select
                        v-model="participantMultipleClasses_"
                        :items="participantMultipleClassesItems"
                        item-text="text"
                        item-value="id"
                        dense
                        outlined
                        :label="$t('dashboard.menu.eventDetails.participantMultipleClasses')"
                        @change="change({ isMultiReg: participantMultipleClasses_.id }, 'isMultiReg')"
                        return-object
                        :hint="$t('dashboard.menu.eventDetails.multiRegToolTipster')"
                        persistent-hint
                        :no-data-text="$t('common.no_data')"
                      ></v-select>
                  </v-col>
                  <v-col md="4" class="col-right">
                    <v-select 
                      v-model="tapType_" 
                      :items="tapTypeItems" 
                      item-text="text" 
                      item-value="id" 
                      dense outlined 
                      :label="$t('dashboard.menu.eventDetails.selectTagType')" 
                      @change="change({ oneTimeTags: tapType_.id }, 'oneTimeTags')" 
                      return-object
                      persistent-hint
                      :hint="event_tags_descr"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-list-item-title>

              <div id="tapType" style="display: none">
                <v-checkbox @change="checkboxUpdated" v-model="checkbox" style="margin-left: 35px" :label="$t('dashboard.menu.eventDetails.llOpt2_request')"></v-checkbox>
                <v-list-item-subtitle class="subtitule">{{ $t("dashboard.menu.eventDetails.llOpt2_request_more") }}</v-list-item-subtitle>
              </div>

              <v-list-item-title class="headline">
                <v-row no-gutters class="mt-4">
                  <v-col md="4" class="col-left">
                      <v-select
                        v-model="buddyRegistration_"
                        :items="buddyRegistrationItems"
                        item-text="text"
                        item-value="id"
                        dense
                        outlined
                        :label="$t('dashboard.menu.eventDetails.buddyRegistration')"
                        @change="change({ isBuddyRegistrationAllowed: buddyRegistration_.id }, 'isBuddyRegistrationAllowed')"
                        return-object
                        :hint="$t('dashboard.menu.eventDetails.isBuddyRegistrationAllowedIconTitle')"
                        persistent-hint
                        :no-data-text="$t('common.no_data')"
                      ></v-select>
                  </v-col>
                  <v-col md="4" class="col-right" >
                    <!--<v-select v-if="buddyRegistration_.id == 1 || buddyRegistration_ == 1"
                      v-model="accountRequired_" 
                      :items="accountRequiredItems" 
                      item-text="text" 
                      item-value="id" 
                      dense outlined 
                      :label="$t('dashboard.menu.eventDetails.accountRequired')" 
                      @change="change({ isBuddyAccountRequired: accountRequired_.id }, 'isBuddyAccountRequired')" sdsada
                      return-object
                    ></v-select>-->
                  </v-col>
                </v-row>
              </v-list-item-title>

               <v-list-item-title class="headline">
                <v-subheader class="title-xs-col">{{ $t("dashboard.menu.eventDetails.numberAssignmentStyle") }}</v-subheader>
                <div class="caption title-xs-col">
                  {{ $t("dashboard.menu.eventDetails.numberAssignmentStyleToolTipster") }}
                </div>
              </v-list-item-title>

              <v-list-item-title class="headline" >
                <v-row no-gutters class="mt-4">
                  <v-col md="4" class="col-left">
                    <v-select 
                      v-model="registrationType_" 
                      :items="registrationTypeItems" 
                      item-text="text" 
                      item-value="id" 
                      dense outlined 
                      :label="$t('dashboard.menu.eventDetails.numberAssignmentStyle')" 
                      @change="change({ registrationType: registrationType_.id }, 'registrationType')" 
                      return-object
                      persistent-hint
                      :hint="numberAssignmentStyle"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                  </v-col>
                  <v-col md="4" class="col-right">
                    <v-text-field v-if="registrationType_.id == 1 || registrationType_ == 1"
                      hide-details="auto"
                      :label="$t('dashboard.menu.eventDetails.rowCount')"
                      v-model="rowCount"
                      outlined
                      dense
                      @input="sendMessage('rowCount')"
                      :hint="$t('dashboard.menu.eventDetails.rowCountToolTipster')"
                      persistent-hint
                      :placeholder="eventDetails.rowCount === undefined ? '' : eventDetails.rowCount.toString()"
                      :disabled="locked"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-list-item-title>

              <v-list-item-title class="headline" v-if="registrationType_.id == 1 || registrationType_ == 1">
                <v-row no-gutters class="mt-4">
                  <v-col md="6" offset-md="3" >
                    <label for="letters" style=" text-align: center !important;">
                      <i class="far fa-text"></i>
                      {{ $t("dashboard.menu.createEvent.letters_label") }}
                    </label>
                    <v-card flat class="letters">
                      <v-card-text class="p0">
                        <v-container fluid>
                          <v-row>
                            <v-col cols="12" sm="2" md="2" v-for="letter in letters" :key="letter.let" class="p0" id="chk_group">
                              <v-checkbox :label="letter.text" v-model="selected" :value="letter.let" hide-details @click="selLetter(letter.let)"></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-list-item-title>

              <v-list-item-title class="headline">
                <v-row no-gutters class="mt-4">
                  <v-col md="4" style="margin: 0 calc(50% + 2rem) 0 auto;">
                    <v-select 
                      v-model="raceNumber_" 
                      :items="raceNumberUniqueBy" 
                      item-text="text" 
                      item-value="id" 
                      dense outlined 
                      :label="$t('dashboard.menu.eventDetails.race_numbers_unique_by')" 
                      @change="change({ isRaceNumUnique: raceNumber_.id }, 'isRaceNumUnique')" 
                      return-object
                      :disabled="isLotteryStyle"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-list-item-title>

            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import Vue from "vue";
import AsyncComputed from "vue-async-computed";
import DatetimePicker from "vuetify-datetime-picker";
import { YES_NO_OPTIONS } from "@/constants/selectOptions";

Vue.use(DatetimePicker);
Vue.use(AsyncComputed);

export default {
  mixins: [apiCalls],
  //props: ["response"],
  data() {
    return {
      event_tags_descr: null,
      menu_: [
        {
          adTitle: false,
        },
        {
          adMessage: false,
        },
        {
          paypalEmail: false,
        },
        {
          maxRegistrants: false,
        },
        {
          waitingListLimit: false,
        },
        {
          registrationType: false,
        },
        {
          rowCount: false,
        },
        {
          regLetters: false,
        },
        {
          regFee: false,
        },
      ],
      eventDetails: [],
      letters: [],
      adTitle: null,
      adMessage: null,
      paypalEmail: null,
      selected:[],
      registrationOpen: null,
      timeProps: {
        // headerColor: process.env.VUE_APP_HEADER_COLOR,
        useSeconds: true,
        format:"24hr"
      },
      textFieldProps: {
        appendIcon: "event",
      },
      registrationClosed: null,
      maxRegistrants: null,
      waitingListLimit: null,
      tapType: null,
      tapType_: null,
      numberAssignmentStyle: null,
      registrationType: null,
      registrationType_: null,
      raceNumber_: null,
      rowCount: null,
      isLoading: false,
      regLetters: null,
      regLetters_: null,
      regFee: null,
      participantMultipleClasses: null,
      participantMultipleClasses_: null,
      accountRequired: null,
      accountRequired_: null,
      buddyRegistration: null,
      buddyRegistration_: null,
      iconIndex: 0,
      checkbox: null,
      locked: null,
      pricingLetterMap: {},
    };
  },
  computed: {
    registrationTypeItems() {
      return [
        { id: 0, text: this.$t("dashboard.menu.eventDetails.lottery_opt1") },
        { id: 1, text: this.$t("dashboard.menu.eventDetails.lottery_opt2") },
        { id: 2, text: this.$t("dashboard.menu.eventDetails.lottery_opt3") },
        { id: 3, text: this.$t("dashboard.menu.eventDetails.lottery_opt4") },
      ];
    },
    raceNumberUniqueBy() {
      return [
        { id: 0, text: this.$t("dashboard.menu.eventDetails.class") },
        { id: 1, text: this.$t("dashboard.menu.eventDetails.event") },
      ];
    },
    isLotteryStyle() {
      return this.registrationType_ === 1 || (this.registrationType_ && this.registrationType_.id === 1);
    },
    tapTypeItems() {
      return [
        { id: 0, text: this.$t("dashboard.menu.eventDetails.event_tags0") },
        { id: 1, text: this.$t("dashboard.menu.eventDetails.event_tags1") },
        { id: 2, text: this.$t("dashboard.menu.eventDetails.event_tags2") },
      ];
    },
    participantMultipleClassesItems() { return YES_NO_OPTIONS(this); },
    accountRequiredItems() { return YES_NO_OPTIONS(this); },
    buddyRegistrationItems() { return YES_NO_OPTIONS(this); }
  },
  asyncComputed: {
    locked: async function () {
      var response = await this.api("get", "/api/v1/promoter/eventDetails/getEventRegistrants/" + this.$route.params.id);

      /*this.eventDescription();
      this.getEventLetters();*/

      return response.message[0]["completed"] + response.message[0]["added"] > 0;
    },
  },
  methods: {
    async eventDescription() {
      let response = await this.api(
        "get",
        "/api/v1/promoter/eventDetails/getEvent/" +
          this.$route.params.id
      );
      if(!response.success){
        this.$router.push({ name: 'EventList', params: {id: this.newRaceId}});
      }
      if(!response.message[0].regOpt){
        this.$router.push({ name: 'EventList', params: {id: this.newRaceId}});
      }

      this.raceNumber_ = response.message[0].isRaceNumUnique == 1 ? 1 : 0;

      this.adTitle = response.message[0].adTitle == null || response.message[0].adTitle == "" ? "" : response.message[0].adTitle;

      response.message[0].adTitle = response.message[0].adTitle == null || response.message[0].adTitle == "" ? this.$t("dashboard.menu.eventDetails.adTitle") : response.message[0].adTitle;


      this.adMessage = response.message[0].adMessage == null || response.message[0].adMessage == "" ? "" : response.message[0].adMessage;

      response.message[0].adMessage = response.message[0].adMessage == null || response.message[0].adMessage == "" ? this.$t("dashboard.menu.eventDetails.adMessage") : response.message[0].adMessage;

      this.paypalEmail = response.message[0].paypalEmail;

      let data = {};

      if (response.message[0].registrationOpen != null) {
        data.timezone = response.message[0].timezone;
        data.datetime = response.message[0].registrationOpen;

        const convertDisplayTime = await this.postApi("/api/v1/promoter/eventDetails/convertDisplayTime", data);

        response.message[0].registrationOpen = convertDisplayTime.message;
        this.registrationOpen = convertDisplayTime.message;
      }

      if (response.message[0].registrationClose != null) {
        data.timezone = response.message[0].timezone;
        data.datetime = response.message[0].registrationClose;

        const convertDisplayTime_ = await this.postApi("/api/v1/promoter/eventDetails/convertDisplayTime", data);

        response.message[0].registrationClose = convertDisplayTime_.message;
        this.registrationClosed = convertDisplayTime_.message;
      }

      this.maxRegistrants = response.message[0].maxRegistrants;
      this.waitingListLimit = response.message[0].waitingListLimit;

      data.parameter = "registrationType";
      data.eventId = this.$route.params.id;

      const registrationType = await this.postApi("/api/v1/promoter/eventDetails/getEventDetail", data);

      switch (registrationType.message) {
        case 0:
          this.numberAssignmentStyle = this.$t("dashboard.menu.eventDetails.simpleNumberToolTipster");
          this.registrationType = this.$t("dashboard.menu.eventDetails.lottery_opt1");
          this.registrationType_ = 0;
          break;
        case 1:
          this.numberAssignmentStyle = this.$t("dashboard.menu.eventDetails.loteryStyleToolTipster");
          this.registrationType = this.$t("dashboard.menu.eventDetails.lottery_opt2");
          this.registrationType_ = 1;
          this.raceNumber_ = 1;
          break;
        case 2:
          this.numberAssignmentStyle = this.$t("dashboard.menu.eventDetails.noAssignmentToolTipster");
          this.registrationType = this.$t("dashboard.menu.eventDetails.lottery_opt3");
          this.registrationType_ = 2;
          break;
        case 3:
          this.numberAssignmentStyle = this.$t("dashboard.menu.eventDetails.participantProvidedNumberToolTipster");
          this.registrationType = this.$t("dashboard.menu.eventDetails.lottery_opt4");
          this.registrationType_ = 3;
          break;
        default:
          this.numberAssignmentStyle = "";
      }
      if(this.registrationType_)
        this.isLoading = true

      data.parameter = "oneTimeTags";

      const oneTimeTags = await this.postApi("/api/v1/promoter/eventDetails/getEventDetail", data);

      switch (oneTimeTags.message) {
        case 0:
          this.tapType = this.$t("dashboard.menu.eventDetails.event_tags0");
          this.event_tags_descr = this.$t("dashboard.menu.eventDetails.event_tags_descr0");
          this.tapType_ = 0;
          break;
        case 1:
          this.tapType = this.$t("dashboard.menu.eventDetails.event_tags1");
          this.event_tags_descr = this.$t("dashboard.menu.eventDetails.event_tags_descr1");
          this.tapType_ = 1;
          break;
        case 2:
          this.tapType = this.$t("dashboard.menu.eventDetails.event_tags2");
          this.event_tags_descr = this.$t("dashboard.menu.eventDetails.event_tags_descr2");
          this.tapType_ = 2;
          document.getElementById("tapType").style.display = "block";
          break;
        default:
          this.numberAssignmentStyle = "";
          this.event_tags_descr = "";
      }

      var getEventTagOption = await this.api("get", "/api/v1/promoter/eventDetails/getEventTagOption/" + this.$route.params.id);

      this.checkbox = getEventTagOption.message;

      data.parameter = "isMultiReg";

      const isMultiReg = await this.postApi("/api/v1/promoter/eventDetails/getEventDetail", data);

      this.participantMultipleClasses = isMultiReg.message == 1 ? this.$t("dashboard.menu.eventDetails.yes") : this.$t("dashboard.menu.eventDetails.no");

      this.participantMultipleClasses_ = isMultiReg.message == 1 ? 1 : 0;

      data.parameter = "isBuddyAccountRequired";

      const isBuddyAccountRequired = await this.postApi("/api/v1/promoter/eventDetails/getEventDetail", data);

      this.accountRequired = isBuddyAccountRequired.message == 1 ? this.$t("dashboard.menu.eventDetails.yes") : this.$t("dashboard.menu.eventDetails.no");

      this.accountRequired_ = isBuddyAccountRequired.message == 1 ? 1 : 0;

      data.parameter = "isBuddyRegistrationAllowed";

      const isBuddyRegistrationAllowed = await this.postApi("/api/v1/promoter/eventDetails/getEventDetail", data);

      this.buddyRegistration = isBuddyRegistrationAllowed.message == 1 ? this.$t("dashboard.menu.eventDetails.yes") : this.$t("dashboard.menu.eventDetails.no");

      this.buddyRegistration_ = isBuddyRegistrationAllowed.message == 1 ? 1 : 0;

      this.rowCount = response.message[0].rowCount;
      this.regFee = response.message[0].regFee;

      this.eventDetails = response.message[0];
      
    },
    async checkboxUpdated(newValue) {
      let data = {};

      data.eventId = this.$route.params.id;
      data.request = newValue ? 1 : 0;

      await this.postApi("/api/v1/promoter/eventDetails/insertTagOptions", data);
    },
    async getEventLetters() {
      var response = await this.api("get", "/api/v1/promoter/eventDetails/getEventLetters/" + this.$route.params.id);

      var separator = ",";
      var implodedArray = response.message.join(separator);

      this.regLetters = implodedArray;
      this.regLetters_ = response.message;
    },
    close(id) {
      this.adTitle = this.eventDetails.adTitle;
      this.adMessage = this.eventDetails.adMessage;
      this.paypalEmail = this.eventDetails.paypalEmail;
      this.maxRegistrants = this.eventDetails.maxRegistrants;
      this.waitingListLimit = this.eventDetails.waitingListLimit;
      this.rowCount = this.eventDetails.rowCount;
      this.regFee = this.eventDetails.regFee;

      this.menu_[id] = false;
    },
    async change(data, parameter) {
      await this.postApi("/api/v1/promoter/eventDetails/updateEvent/" + this.$route.params.id, data);

      if (parameter == "registrationType") {
        switch (data.registrationType) {
          case 0:
            this.numberAssignmentStyle = this.$t("dashboard.menu.eventDetails.simpleNumberToolTipster");
            this.registrationType = this.$t("dashboard.menu.eventDetails.lottery_opt1");
            break;
          case 1:
            this.numberAssignmentStyle = this.$t("dashboard.menu.eventDetails.loteryStyleToolTipster");
            this.registrationType = this.$t("dashboard.menu.eventDetails.lottery_opt2");
            this.raceNumber_ = 1;
            await this.postApi("/api/v1/promoter/eventDetails/updateEvent/" + this.$route.params.id, { isRaceNumUnique: 1 });
            break;
          case 2:
            this.numberAssignmentStyle = this.$t("dashboard.menu.eventDetails.noAssignmentToolTipster");
            this.registrationType = this.$t("dashboard.menu.eventDetails.lottery_opt3");
            break;
          case 3:
            this.numberAssignmentStyle = this.$t("dashboard.menu.eventDetails.participantProvidedNumberToolTipster");
            this.registrationType = this.$t("dashboard.menu.eventDetails.lottery_opt4");
            break;
          default:
            this.numberAssignmentStyle = "";
        }
      } else if (parameter == "oneTimeTags") {
        switch (data.oneTimeTags) {
          case 0:
            this.tapType = this.$t("dashboard.menu.eventDetails.event_tags0");
            this.event_tags_descr = this.$t("dashboard.menu.eventDetails.event_tags_descr0");
            document.getElementById("tapType").style.display = "none";
            break;
          case 1:
            this.tapType = this.$t("dashboard.menu.eventDetails.event_tags1");
            this.event_tags_descr = this.$t("dashboard.menu.eventDetails.event_tags_descr1");
            document.getElementById("tapType").style.display = "none";
            break;
          case 2:
            this.tapType = this.$t("dashboard.menu.eventDetails.event_tags2");
            this.event_tags_descr = this.$t("dashboard.menu.eventDetails.event_tags_descr2");
            document.getElementById("tapType").style.display = "block";
            break;
          default:
            this.numberAssignmentStyle = "";
            this.event_tags_descr = "";
        }
      } else if (parameter == "isMultiReg") {
        this.participantMultipleClasses = data.isMultiReg == 1 ? this.$t("dashboard.menu.eventDetails.yes") : this.$t("dashboard.menu.eventDetails.no");
      } else if (parameter == "isBuddyAccountRequired") {
        this.accountRequired = data.isBuddyAccountRequired == 1 ? this.$t("dashboard.menu.eventDetails.yes") : this.$t("dashboard.menu.eventDetails.no");
      } else if (parameter == "isRaceNumUnique") {
        this.raceNumber = data.raceNumber == 0 ? this.$t("dashboard.menu.eventDetails.class") : this.$t("dashboard.menu.eventDetails.event");
      } else {
        this.buddyRegistration = data.isBuddyRegistrationAllowed == 1 ? this.$t("dashboard.menu.eventDetails.yes") : this.$t("dashboard.menu.eventDetails.no");
      }
      
    },
    async sendMessage(input) {
      let data = {};

      if (input == "adTitle") {
        data.adTitle = this.adTitle;
      } else if (input == "adMessage") {
        data.adMessage = this.adMessage;
      } else if (input == "paypalEmail") {
        data.paypalEmail = this.paypalEmail;
      } else if (input == "maxRegistrants") {
        data.maxRegistrants = this.maxRegistrants;
      } else if (input == "waitingListLimit") {
        data.waitingListLimit = this.waitingListLimit;
      } else if (input == "rowCount") {
        data.rowCount = this.rowCount;
      } else if (input == "regLetters") {
        let letrasSel = this.letters.filter((x) => x.sel == true);
        let letrasMar = "";
        letrasSel.forEach((x) => {
            letrasMar += x.text + ",";
        });
        letrasMar = letrasMar.substr(0, letrasMar.length - 1);
        letrasMar.length > 0 ? (data.regLetters = letrasMar) : "";
      } else if (input == "regFee") {
        data.regFee = this.regFee;
      }

      await this.postApi("/api/v1/promoter/eventDetails/updateEvent/" + this.$route.params.id, data);

      this.eventDetails.adTitle = this.adTitle == null || this.adTitle == "" ? this.$t("dashboard.menu.eventDetails.adTitle") : this.adTitle;

      this.eventDetails.adMessage = this.adMessage == null || this.adMessage == "" ? this.$t("dashboard.menu.eventDetails.adMessage") : this.adMessage;

      this.eventDetails.paypalEmail = this.paypalEmail;
      this.eventDetails.maxRegistrants = this.maxRegistrants;
      this.eventDetails.waitingListLimit = this.waitingListLimit;
      this.eventDetails.rowCount = this.rowCount;
      this.eventDetails.regFee = this.regFee;

      this.menu_[input] = false;
    },
    getDate(datetime) {
      let fullDate = new Date(datetime);
      let date = fullDate.toLocaleDateString().split("/");
      let minutes = fullDate.toLocaleTimeString().slice(0, 7).split(":");

      let [month, day, year] = date;
      let [hour, minute, second] = minutes;

      if (month < 10) month = "0" + month;

      if (day < 10) day = "0" + day;

      if (hour < 10) hour = "0" + hour;

      let newDate = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;

      return newDate;
    },
    saveRegistrationOpen: async function (datetime) {
      let data = {};

      data.registrationOpen = this.getDate(datetime);

      await this.postApi("/api/v1/promoter/eventDetails/updateEvent/" + this.$route.params.id, data);
    },
    saveRegistrationClose: async function (datetime) {
      let data = {};

      data.registrationClose = this.getDate(datetime);

      await this.postApi("/api/v1/promoter/eventDetails/updateEvent/" + this.$route.params.id, data);
    },
    resetIcon() {
      this.iconIndex = 0;
    },
    changeIcon() {
      this.iconIndex === this.icons.length - 1 ? (this.iconIndex = 0) : this.iconIndex++;
    },
    async getLetters() {
      const getLetters = await this.api("get", "/api/v1/promoter/createEvent/getLetterRange");
      let arrayItems = [];

      Object.entries(getLetters.message).forEach(([value, key]) => {
        arrayItems.push({
          let: value,
          text: key,
          sel: false,
        });
      });
      this.letters = arrayItems;
      let i = 0;
      
      this.regLetters_.filter((x1) => {
        this.letters.filter((x) => {
          if (x.text == x1 && x.sel == false) {
            x.sel = true;
            this.selected[i] = ""+x.let
            i++
          } else if (x.text == x1 && x.sel == true) {
            x.sel = false;
          }
        });

      });
       
    },
    async loadPricingLetterUsage() {
      try {
        const response = await this.api("get", "/api/v1/promoter/eventRegistrationPrice/" + this.$route.params.id);
        if (response.success) {
          const eventLetters = response.message.eventLetters || [];
          const pricingOptions = response.message.data || [];
          const letterIdToText = {};
          eventLetters.forEach((l) => { letterIdToText[l.id] = l.letter.toUpperCase(); });
          const map = {};
          pricingOptions.forEach((opt) => {
            (opt.allowedLetterIds || []).forEach((lid) => {
              const letterText = letterIdToText[lid];
              if (letterText) {
                if (!map[letterText]) map[letterText] = [];
                map[letterText].push(opt.description);
              }
            });
          });
          this.pricingLetterMap = map;
        }
      } catch (e) {
        this.pricingLetterMap = {};
      }
    },
    selLetter(_letter) {
      const letterObj = this.letters.find((x) => x.let == _letter);
      if (letterObj && letterObj.sel == true) {
        const letterText = letterObj.text.toUpperCase();
        const usedBy = this.pricingLetterMap[letterText];
        if (usedBy && usedBy.length > 0) {
          const names = usedBy.join(", ");
          if (!confirm("This letter (" + letterText + ") is assigned to pricing option(s): " + names + ". Removing it will also delete it from those pricing options. Continue?")) {
            return;
          }
        }
      }
      let letrasSel = this.letters.filter((x) => x.sel == true);
      let max=false, selectedT = [];
      if(letrasSel.length < this.rowCount){
        max=true
      }else{
        for(var i =0 ; i< this.rowCount; i++){
          if(this.selected[i])
            selectedT[i] = this.selected[i]
        }
        this.selected = selectedT 
      }
      this.letters.filter((x) => {
        if (x.let == _letter && x.sel == false && max) {
          x.sel = true;
        } else if (x.let == _letter && x.sel == true) {
          x.sel = false;
        }
      });
      this.sendMessage('regLetters')
      this.loadPricingLetterUsage();
    },

  },
  created: async function () {
    this.navigationBGColor = process.env.VUE_APP_HEADER_COLOR;
    this.getEventLetters();
    this.getLetters();
    this.loadPricingLetterUsage();
  },
  mounted() {
    this.eventDescription();
  }
};
</script>

<style>
.v-subheader.title-xs-col { margin: 0 0 0 14%; padding: 0 !important; }
.caption.title-xs-col { margin: -15px 0 0 14%; }
.col-left { margin: 0 2rem 0 auto; }
.col-right { margin: 0 auto 0 2rem; }
@media (max-width: 874px) {
  .col { flex-basis: auto; margin: 0 !important; }
  .v-subheader.title-xs-col { margin: 0 !important; padding: 0 !important; }
  .caption.title-xs-col { margin: -15px 0 0; }
}
.datetime-outline .v-input__slot{
    border: 1px solid rgba(0, 0, 0, 0.4);
    padding: 0 12px;
    border-radius: 4px;
    min-height: 40px;
    margin-bottom: 0;
}
.datetime-outline .v-label {
  background-color: var(--v-lighten-base);
  padding: 0 5px;
}
.datetime-outline .v-text-field__details {
  min-height: 0;
  height: 0;
}
.datetime-outline .caption {
  color: var(--v-primary-base);
}
.subtitule {
  margin-left: 22px !important;
}
.registrationSetup .v-text-field__details {
  min-width: 0;
}
.v-application--is-ltr .v-text-field .v-label {
    color: rgb(133, 133, 133);
}
.letters {
  border: solid 1px #ccc !important;
}
.v-messages__message {
    white-space: initial !important;
}

</style>
